module.exports = __webpack_public_path__ + "img/example1.0090e753.jpg";